/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from "react";
import {BaseFieldEditor} from "./BaseFieldEditor";
import {service as SurveyQuestionDataTypeService} from "../../../Services/SurveyQuestionDataTypeService";
import autobind from "autobind-decorator";
import {FormControl} from "react-bootstrap";

export class SurveyQuestionDataTypeFieldEditor extends BaseFieldEditor {
	constructor(props) {
		super(props)

		this.setInitialState({
			surveyQuestionDataTypes: []
		});
	}

	componentDidMount() {
		SurveyQuestionDataTypeService.Get()
			.then((x) => {
				this.setState({surveyQuestionDataTypes: x.result});
			});
	}

	@autobind
	_render() {
		return <FormControl
			as="select"
			placeholder="Select A Data Type"
			value={this.props.Value != null ? this.props.Value : ""}
			onChange={(x) => this.props.OnUpdate(x.target.value)}
		>
			<option value="">Select A Data Type</option>
			{
				this.state.surveyQuestionDataTypes
					.sort((a, b) => a.name.localeCompare(b.name))
					.map((x) => {
						return <option key={x.surveyQuestionDataTypeId}
						               value={x.surveyQuestionDataTypeId}>{x.name}</option>;
					})
			}
		</FormControl>;
	}
}